import { AudienceFormInitialValues, OfferFulfillment } from '@occc-app/routes/Audience/types';
import { Fuel_And_Convenience_Profile_Operator, Offer_Activation_Operator } from '@occc/graphql';
import { walletSteeringItemInitialValues } from '@occc-app/routes/Audience/components/WalletSteering/constants';
import { productInterestsInitialValues } from '@occc-app/routes/Audience/components/ProductInterests/constants';
import {
  lastVisitInitialFormValues,
  qualifiedEventsInitialFormValues,
} from '@occc-app/routes/Audience/components/QualifiedEvents/constants';

import {
  membershipCreatedInitialFormValues,
  pointBalanceInitialFormValues,
} from '../components/FuelAndConvenienceProfile/constants';
import { surveysInitialFormValues } from '../components/Surveys/constants';
import { combinedAudiencesInitialValues } from '../components/CombinedAudiences/constants';
import { audiencePurchasesInitialFormValues } from '../components/Purchases/constants';
import { externalIdentityVerificationInitialValues } from '../components/ExternalIdentityVerification/externalIdentityVerificationInitialValues';

export const audienceFormInitialValues: AudienceFormInitialValues = {
  name: '',
  description: '',
  purchases: [{ ...audiencePurchasesInitialFormValues }],
  fulfillments: [
    {
      fulfilled: OfferFulfillment.Fulfilled,
      targetOffer: null,
    },
  ],
  offerActivations: [
    {
      operator: Offer_Activation_Operator.IsActivated,
      targetOffer: null,
    },
  ],
  birthdayMonths: [],
  behaviors: {
    eaivVerified: Fuel_And_Convenience_Profile_Operator.IsIn,
    eaivAttributes: [],
  },
  communicationPreferences: {
    sms: { status: '', subBrandUuid: '' },
    push: { status: '', subBrandUuid: '' },
  },
  walletSteeringItems: [
    {
      ...walletSteeringItemInitialValues,
    },
  ],
  productInterests: {
    ...productInterestsInitialValues,
  },
  qualifiedEvents: [
    {
      ...qualifiedEventsInitialFormValues,
    },
  ],
  lastVisit: lastVisitInitialFormValues,
  pointBalance: pointBalanceInitialFormValues,
  membershipCreated: membershipCreatedInitialFormValues,
  surveys: [surveysInitialFormValues],
  combinedAudiences: combinedAudiencesInitialValues,
  externalIdentityVerification: externalIdentityVerificationInitialValues,
};
